import omit from 'lodash/omit';
import mapValues from 'lodash/mapValues';

export const SessionStateSatisfaction = data => ({
  rating: data.rating,
  answers: data.answers,
});

export const SessionStateSession = data => ({
  satisfaction: new SessionStateSatisfaction(data.satisfaction),
});

export const SessionState = data => mapValues(data, session => new SessionStateSession(session));

export const responseDataToSessionState = responseData => {
  return new SessionState(omit(responseData.attributes, 'expiresAt'));
};

export const responseToSessionState = response => {
  return responseDataToSessionState(response.data.data);
};
